window.HomeyaCart = (() => {
  const drawer = () => document.querySelector('.homeya-cart-drawer');
  const overlay = () => document.querySelector('.homeya-cart-overlay');

  async function open() {
    // Hydrate the drawer from Shopify every time it opens so items added
    // through any product form are visible immediately.
    try { await refresh(); } catch (e) { console.warn('HOMEYA: nie udało się odświeżyć koszyka.', e); }
    drawer()?.classList.add('is-open');
    overlay()?.classList.add('is-open');
    drawer()?.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('cart-open');
  }
  function close() {
    drawer()?.classList.remove('is-open');
    overlay()?.classList.remove('is-open');
    drawer()?.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('cart-open');
  }

  function money(cents) {
    return (cents / 100).toLocaleString('pl-PL', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' zł';
  }

  function render(cart) {
    const count = document.querySelector('#CartCount');
    const drawerCount = document.querySelector('#DrawerCount');
    const body = document.querySelector('#HomeyaCartBody');
    const footer = document.querySelector('#HomeyaCartFooter');
    const subtotal = document.querySelector('#DrawerSubtotal');

    if (count) count.textContent = cart.item_count;
    if (drawerCount) drawerCount.textContent = cart.item_count;
    if (subtotal) subtotal.textContent = money(cart.total_price);

    if (!body || !footer) return;

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = `
        <div class="cart-empty">
          <div class="empty-icon">
            <svg viewBox="0 0 24 24"><path d="M5 8h14l-1 12H6L5 8Z"></path><path d="M9 9V6a3 3 0 0 1 6 0v3"></path></svg>
          </div>
          <h3>Koszyk czeka na Ciebie.</h3>
          <p>Dodaj coś, co dobrze pasuje do Twojego domu.</p>
          <a href="/collections/all" onclick="HomeyaCart.close()">Przejdź do sklepu&nbsp; →</a>
        </div>`;
      footer.style.display = 'none';
      return;
    }

    body.innerHTML = `
      <div class="drawer-items">
        ${cart.items.map(item => `
          <div class="drawer-item" data-line-key="${String(item.key).replace(/"/g,'&quot;')}">
            <img class="drawer-item-image" src="${item.image || ''}" alt="${(item.product_title || '').replace(/"/g,'&quot;')}">
            <div class="drawer-item-info">
              <div class="drawer-item-title">${item.product_title || 'Produkt HOMEYA'}</div>
              <div class="drawer-item-variant">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
              <div class="drawer-item-bottom">
                <div class="drawer-qty" aria-label="Ilość">
                  <button type="button" aria-label="Zmniejsz ilość" onclick="HomeyaCart.change('${String(item.key).replace(/'/g,"\\\\'")}', ${Math.max(0, item.quantity - 1)})">−</button>
                  <span>${item.quantity}</span>
                  <button type="button" aria-label="Zwiększ ilość" onclick="HomeyaCart.change('${String(item.key).replace(/'/g,"\\\\'")}', ${item.quantity + 1})">＋</button>
                </div>
                <strong>${money(item.final_line_price)}</strong>
              </div>
            </div>
            <button class="drawer-remove" type="button" aria-label="Usuń produkt" onclick="HomeyaCart.change('${String(item.key).replace(/'/g,"\\\\'")}', 0)">×</button>
          </div>`).join('')}
      </div>`;
    footer.style.display = 'block';
  }

  async function refresh() {
    const cart = await fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(r => r.json());
    render(cart);
    return cart;
  }

  async function add(form) {
    const button = form.querySelector('[data-homeya-add]');
    if (button) { button.disabled = true; button.classList.add('is-loading'); }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Accept':'application/json'},
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('add failed');
      await refresh();
      open();
    } catch (e) {
      console.error('HOMEYA: nie udało się dodać produktu do koszyka.', e);
      alert('Nie udało się dodać produktu do koszyka. Sprawdź, czy produkt ma dostępną wersję.');
      return;
    } finally {
      if (button) { button.disabled = false; button.classList.remove('is-loading'); }
    }
  }

  async function change(key, quantity) {
    const response = await fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key, quantity})
    });
    if (response.ok) {
      await refresh();
      open();
    }
  }

  return {open, close, add, change, refresh};
})();

document.addEventListener('DOMContentLoaded', () => {
  const shopTrigger = document.querySelector('.shop-nav-trigger');
  const shopDropdown = document.querySelector('#HomeyaShopMenu');

  function closeShopMenu() {
    if (!shopTrigger || !shopDropdown) return;
    shopTrigger.setAttribute('aria-expanded', 'false');
    shopDropdown.classList.remove('is-open');
    shopDropdown.hidden = true;
  }

  function toggleShopMenu() {
    if (!shopTrigger || !shopDropdown) return;
    const open = shopTrigger.getAttribute('aria-expanded') === 'true';
    if (open) {
      closeShopMenu();
      return;
    }
    shopTrigger.setAttribute('aria-expanded', 'true');
    shopDropdown.hidden = false;
    requestAnimationFrame(() => shopDropdown.classList.add('is-open'));
  }

  shopTrigger?.addEventListener('click', toggleShopMenu);
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.shop-nav-wrap')) closeShopMenu();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeShopMenu();
  });
  shopDropdown?.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => closeShopMenu());
  });

  // Populate the drawer on initial page load too. The Liquid drawer only
  // prints the empty state server-side, so an existing cart would otherwise
  // show a blank body even though CartCount is correct.
  HomeyaCart.refresh().catch((e) => console.warn('HOMEYA: nie udało się wczytać koszyka.', e));

  setupLightToggle();
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.matches('#homeya-product-form, #homeya-product-detail-form')) {
      e.preventDefault();
      HomeyaCart.add(form);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') HomeyaCart.close();
  });
});


function setupLightToggle() {
  const onImage = document.querySelector('#HomeyaProductImageOn');
  const offImage = document.querySelector('#HomeyaProductImageOff');
  const badge = document.querySelector('#HomeyaLightBadge');
  const container = document.querySelector('[data-light-switcher]');
  const buttons = document.querySelectorAll('[data-light-state]');
  if (!onImage || !offImage || !buttons.length) return;

  function setState(isOn, animate = true) {
    container?.classList.toggle('light-is-off', !isOn);
    if (animate) {
      container?.classList.remove('light-transitioning');
      void container?.offsetWidth;
      container?.classList.add('light-transitioning');
      window.setTimeout(() => container?.classList.remove('light-transitioning'), 900);
    }

    buttons.forEach((btn) => {
      const active = (btn.dataset.lightState === 'on') === isOn;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    if (badge) {
      badge.innerHTML = isOn
        ? '● &nbsp; ŚWIATŁO WŁĄCZONE'
        : '● &nbsp; ŚWIATŁO WYŁĄCZONE';
    }
  }

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      setState(button.dataset.lightState === 'on', true);
    });
  });

  setState(true, false);
}



document.addEventListener('click', (e) => {
  const jump = e.target.closest('[data-faq-target]');
  if (!jump) return;
  e.preventDefault();
  const id = jump.getAttribute('data-faq-target');
  const target = document.getElementById(id);
  if (target) {
    target.scrollIntoView({behavior:'smooth', block:'start'});
    history.replaceState(null, '', '#' + id);
  }
});
